import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrandLogo } from './components/brand-logo/brand-logo';
import { MenubarModule } from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { InputMaskModule } from 'primeng/inputmask';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { AdminHeader } from './components/admin-header/admin-header';
import { AdminFooter } from './components/admin-footer/admin-footer';

const PRIMENG_MODULES = [
  ButtonModule,
  MenubarModule,
  AvatarModule,
  MenuModule,
  ToastModule,
  DialogModule,
  TableModule,
  SelectModule,
  TooltipModule,
  InputMaskModule,
  PasswordModule,
  CheckboxModule,
];

@NgModule({
  declarations: [AdminHeader, AdminFooter],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    BrandLogo,
    ...PRIMENG_MODULES,
  ],
  exports: [
    AdminHeader,
    AdminFooter,
    BrandLogo,
    ...PRIMENG_MODULES,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
  ],
})
export class SharedModule {}
